import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import logo from '../logo.png';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const services = [
    { name: 'Software Development', path: '/services/software-development' },
    { name: 'Android Development', path: '/services/android-development' },
    { name: 'Offshore Software Testing', path: '/services/software-testing' },
    { name: 'Data Warehouse Management', path: '/services/data-warehouse' }
  ];

  return (
    <header className="header-container">
      <nav className="nav-wrapper">
        <div className="nav-content">
          {/* Logo */}
          <Link to="/" className="logo">
            <img className='logo-image'  src={logo} alt="Logo"  />
            <span className="logo-text">StoryBox Solutions</span>
            {/* <span className="logo-subtext">Solutions</span> */}
          </Link>

          {/* Desktop Navigation */}
          <div className="desktop-nav">
            <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
              Home
            </Link>

            {/* Services Dropdown */}
            <div
              className="services-dropdown"
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
            >
              <button className={`nav-link ${location.pathname.includes('/services') ? 'active' : ''}`}>
                Services
                <ChevronDown className="chevron-icon" />
              </button>
              {isServicesOpen && (
                <div className="dropdown-menu">
                  {services.map((service) => (
                    <Link
                      key={service.path}
                      to={service.path}
                      className="dropdown-item"
                    >
                      {service.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link to="/products" className={`nav-link ${isActive('/products') ? 'active' : ''}`}>
              Products
            </Link>
            <Link to="/about" className={`nav-link ${isActive('/about') ? 'active' : ''}`}>
              About
            </Link>
            <Link to="/team" className={`nav-link ${isActive('/team') ? 'active' : ''}`}>
              Team
            </Link>
            <Link to="/vision" className={`nav-link ${isActive('/vision') ? 'active' : ''}`}>
              Vision & Mission
            </Link>
            <Link to="/career" className={`nav-link ${isActive('/career') ? 'active' : ''}`}>
              Career
            </Link>
            <Link to="/contact" className="nav-link-cta">
              Contact Us
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="mobile-nav">
            <Link to="/" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>
              Home
            </Link>
            <div className="mobile-services-section">
              <span className="mobile-nav-label">Services</span>
              {services.map((service) => (
                <Link
                  key={service.path}
                  to={service.path}
                  className="mobile-nav-sublink"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {service.name}
                </Link>
              ))}
            </div>
            <Link to="/products" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>
              Products
            </Link>
            <Link to="/about" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>
              About
            </Link>
            <Link to="/team" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>
              Team
            </Link>
            <Link to="/vision" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>
              Vision & Mission
            </Link>
            <Link to="/career" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>
              Career
            </Link>
            <Link to="/contact" className="mobile-nav-link-cta" onClick={() => setIsMobileMenuOpen(false)}>
              Contact Us
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
